import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {UserInfoService} from '../api/user-info.service';
import {map} from 'rxjs/operators';
import {UserInfoModel} from '../api/user-info-model';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private userInfoService: UserInfoService){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log('IsAdminGuard#canActivate called');
    return this.userInfoService.get()
      // preload user data
      .pipe(map<UserInfoModel, boolean>(x => true));
  }
}
